import { css } from 'lit';

export default css`
    .view {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: var(--color-surface-secondary);
        padding: var(--metrics-spacing-s);
        overflow: hidden;
    }

    ki-ds-pwa-graph-container {
        flex: 1;
        min-height: 0;
    }
`;
